import React from 'react';
import '../../styles/styles.css';

export default function palani() {
  return (
    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/palani.jpeg" alt="Palani Temple Hill" />    
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Next Festival Date in Palani<br />
    Thai Pusam : 01st February, 2026<br />    
    <br />

  </strong></p>
  <p>Palani Official Seva Booking Website : <a href="https://palanimurugan.hrce.tn.gov.in/" target="_blank" rel="noopener noreferrer">
  Palani Temple Official Website
</a>
</p> 
 </div>
            </div>
        </div>

        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Murugan Temple is situated on top of Palani Hill. Murugan is placed in the sanctum sanctorum and is holding a kol (rod) in Andi`s kolam. This sculpture is not made of stone like other sculptures. The Palani temple is special for its unique Navapashanam idol of Lord Murugan, created by the sage Bhogar from nine poisonous materials, which is believed to have healing properties. The temple is a significant spiritual center, famous for the sweet Prasad Palani Panchamirtham, which holds a geographical indication tag. It is also a vibrant hub for festivals like Thai Poosam and a rich spiritual destination within the backdrop of the Western Ghats. Shanmukha river is 2 km west of this place. It is interpreted as a holy solution. The Six Rivers namely Palaru, Varatharu, Bhatularu, Suruliyaru, Kallaru and Pachaiyaru come together to form the name Shanmukha River. </p>
             </div>
        </div>
        {/* YouTube Section */}
      <div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Palani Temple Documentary</h2>
            <div className="youtube-container">
              <iframe
                src="https://www.youtube.com/embed/9Xlbz5BpIAY?rel=0&modestbranding=1&showinfo=0"
                title="Palani Temple"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>

   </div>
  )
}
